import { render } from "./DriveDesktopAddFiles.vue?vue&type=template&id=32aeb774&scoped=true&ts=true"
import script from "./DriveDesktopAddFiles.vue?vue&type=script&lang=ts"
export * from "./DriveDesktopAddFiles.vue?vue&type=script&lang=ts"

import "./DriveDesktopAddFiles.vue?vue&type=style&index=0&id=32aeb774&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32aeb774"]])

export default __exports__